import { auditConstants } from './audit.constants'

const auditState = {
  globalAudits: [],
  loadingGlobalAudits: false,
}

export function audit(state = auditState, action) {
  switch (action.type) {
    case auditConstants.FETCH_GLOBAL_AUDITS_LOADING:
      return {
        ...state,
        loadingGlobalAudits: true,
      }
    case auditConstants.FETCH_GLOBAL_AUDITS_SUCCESS:
      return {
        ...state,
        loadingGlobalAudits: false,
        globalAudits: action.audits,
      }
    case auditConstants.FETCH_GLOBAL_AUDITS_ERROR:
      return {
        ...state,
        loadingGlobalAudits: false,
      }
    default:
      return state
  }
}
